export const MODAL_CONFIG = {
  reset: {
    title: "Resetare la valorile initiale",
    descriptionWithChanges: "Următoarele modificări vor fi pierdute:",
    descriptionNoChanges: "Nu există modificări față de valorile initiale.",
    emptyStateMessage: "Valorile curente sunt identice cu cele initiale.",
    emptyStateSubMessage: "Resetarea va reîncărca aceleași valori.",
    buttonTextAll: "Resetare la valorile initiale",
    buttonTextPartial: "Resetează selecțiile",
    buttonTextNoChanges: "OK",
    cancelText: "Anulează",
    toastTitleSuccess: "Resetare completă",
  },
  save: {
    title: "Salvare modificări",
    descriptionWithChanges:
      "Următoarele modificări vor fi salvate în baza de date:",
    descriptionNoChanges: "Nu există modificări de salvat.",
    emptyStateMessage: "Nu există modificări față de valorile salvate.",
    emptyStateSubMessage: "Matricea este deja sincronizată cu baza de date.",
    buttonTextAll: "Salvează toate modificările",
    buttonTextPartial: "Salvează modificările selectate",
    buttonTextNoChanges: "OK",
    cancelText: "Anulează",
    warningPartialSave:
      "⚠️ Modificările neselectate NU vor fi salvate și se vor pierde.",
    toastTitleSuccess: "Modificări salvate",
  },
} as const;
